import React, { useState, useCallback, useRef, useEffect } from 'react';
import { FormThemeProvider } from "react-md";

import { ButtonPostulation, ContainerFormulario } from './styled.component';
import ClockLoader from "react-spinners/ClockLoader";
import {
    defaultGetErrorMessage,
    Form,
    TextFieldWithMessage,
    useChecked,
    useTextField,
    FileInput,
    NativeSelect
} from "@react-md/form";
import { Button } from 'react-md';
import { notifica } from '../../requests/utils';
import { DeleteSVGIcon } from '@react-md/material-icons';
import { getEstados } from '../../requests/Ofertas';

export const FormularioPostulacion = ({ _this }) => {

    const onErrorChange = useCallback(
        (id, error) => setErrors((prevErrors) => ({ ...prevErrors, [id]: error })),
        []
    );

    const [file, setFile] = useState("");
    const [isIcon, handleIconChange] = useChecked(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [states, setStates] = useState();
    const [idEstado, setIdEstado] = useState("");

    useEffect(() => {
        getEstados().then((response) => setStates(response))
    }, [])


    const onChange = useCallback(
        (event) => {
            const [file] = Array.from(event.currentTarget.files || [null]);

            if (file) {
                // Verificar el tipo de archivo
                if (!esTipoArchivoPermitido(file)) {
                    notifica("warning", "Por favor, selecciona un archivo válido (Word o PDF).", "Advertencia");
                    event.currentTarget.value = "";
                } else {
                    setFile(event.target.files[0]);
                }
            }
        },
        []
    );

    const esTipoArchivoPermitido = (file) => {
        // Lista de tipos MIME permitidos (Word y PDF en este caso)
        const tiposPermitidos = ["application/msword", "application/pdf"];
        return tiposPermitidos.includes(file.type);
    };

    const eliminarArchivo = () => {
        // Función para eliminar el archivo seleccionado
        setFile(null);
    };

    const [_name, nameFieldProps] = useTextField({
        id: "name",
        required: true,
        onErrorChange,
    });

    const [_apellidoP, apellidoPFieldProps] = useTextField({
        id: "apellidoP",
        required: true,
        onErrorChange,
    });

    const [_apellidoM, apellidoMFieldProps] = useTextField({
        id: "apellidoM",
        required: true,
        onErrorChange,
    });


    const [_telefono, telefonoFieldProps] = useTextField({
        id: "telefono",
        required: true,
        onErrorChange,
        minLength: 10,
        maxLength: 10,
        pattern: "^[0-9]*$",
        transform: (value) => {
            return value.replace(/\D/g, '').slice(0, 10);
        },
    });

    const validateNumber = (evt) => {
        var e = evt || window.event;
        var key = e.keyCode || e.which;

        if (!e.shiftKey && !e.altKey && !e.ctrlKey &&
            // numbers   
            key >= 48 && key <= 57 ||
            // Numeric keypad
            key >= 96 && key <= 105 ||
            // Backspace and Tab and Enter
            key == 8 || key == 9 || key == 13 ||
            // Home and End
            key == 35 || key == 36 ||
            // left and right arrows
            key == 37 || key == 39 ||
            // Del and Ins
            key == 46 || key == 45) {
            // input is VALID
        }
        else {
            // input is INVALID
            e.returnValue = false;
            if (e.preventDefault) e.preventDefault();
        }
    }



    const handleSubmit = async () => {
        // Validar que todos los campos obligatorios estén llenos
        if (!_name || !_apellidoP || !_apellidoM || !_telefono || !file || !idEstado ) {
            notifica("warning", "Por favor complete todos los campos y suba su CV antes de postularse.", "Advertencia");
            return;
        }

        if (_telefono.length < 10) {
            notifica("warning", "El teléfono debe contener exactamente 10 dígitos. ¡Por favor, verifica tu número antes de postularte!", "Advertencia");
            return;
        }
        // Actualizar el estado para mostrar el loader usando el ref


        setIsLoading(true);

        try {
            // Realizar la acción de postulación
            await _this.postularse({ _name, _apellidoP, _apellidoM, _telefono, file , idEstado});

            // If successful, set loading to false to hide the loader
            setIsLoading(false);

            // You can perform additional actions after the postulation is complete if needed
            // ...

        } catch (error) {
            // Handle errors if any
            console.error("Error during postulation:", error);

            // Set loading to false in case of an error
            setIsLoading(false);
        }
    };

    return (
        <>
            <ContainerFormulario>
                <FormThemeProvider theme={"filled"}>
                    <div className="close-icon" onClick={(e) => _this.isOpenFormulario(e)}>x</div>
                    <Form className="container">
                        <div className='container-inputs-flex'>
                            <TextFieldWithMessage
                                {...nameFieldProps}
                                label="Nombre"
                                placeholder="Nombre"
                                name="name"
                            />
                            <TextFieldWithMessage
                                {...apellidoPFieldProps}
                                label="Apellido Paterno"
                                placeholder="Apellido Paterno"
                                name="apellidoPaterno"
                            />
                        </div>

                        <div className='container-inputs-flex'>
                            <TextFieldWithMessage
                                {...apellidoMFieldProps}
                                label="Apellido Materno"
                                placeholder="Apellido Materno"
                                name="apellidoMaterno"
                            />
                            <TextFieldWithMessage
                                {...telefonoFieldProps}
                                label="Teléfono"
                                placeholder="Teléfono"
                                name="telefono"
                                type="tel"
                                onInput={(e) => {
                                    const inputValue = e.target.value;

                                    // Reemplaza cualquier carácter que no sea un número con una cadena vacía
                                    const cleanedValue = inputValue.replace(/[^0-9]/g, '');

                                    // Actualiza el valor del campo con solo números
                                    e.target.value = cleanedValue;
                                }}
                            />
                        </div>
                        <div className='container-inputs-flex'>
                            <NativeSelect
                                id="select-states"
                                name="select"
                                label="Localidad"
                                value={idEstado}
                                onChange={(event) => setIdEstado(event.currentTarget.value)}
                            >
                                <option value="" disabled hidden />
                                {states?.map(({ nombre, idEstado }) => (
                                    <option key={idEstado} value={idEstado}>
                                        {nombre}
                                    </option>
                                ))}
                            </NativeSelect>
                        </div>


                        {!file ? <FileInput
                            id="configurable-file-input"
                            onChange={onChange}
                            theme={"warning"}
                            themeType={"flat"}
                            buttonType={isIcon ? "icon" : "text"}
                            disableIconSpacing={!file}
                            accept="application/msword, application/pdf"
                        >
                            SUBIR CV
                        </FileInput> :
                            <div className='file-input'>
                                {file.name}{' '}
                                <Button
                                    theme="secondary"
                                    buttonType="icon"
                                    onClick={eliminarArchivo}
                                    className="button-delete"
                                >
                                    <DeleteSVGIcon />
                                </Button>
                            </div>
                        }

                    </Form>
                    <div className="btn-iniciar">
                        {isLoading ? (
                            <ClockLoader color={"#f5a796"} size={30} />
                        ) : (
                            <ButtonPostulation
                                id="btnlopo"
                                onClick={handleSubmit}
                            >
                                Postularme
                            </ButtonPostulation>
                        )}
                    </div>
                </FormThemeProvider>
            </ContainerFormulario >
        </>
    )
}
